import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromLinksStore from './links-store.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LinksStoreEffects } from './links-store.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromLinksStore.linksStoreFeatureKey, fromLinksStore.reducer),
    EffectsModule.forFeature([LinksStoreEffects])
  ]
})
export class LinksStoreModule { }
